var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _g, _mask2, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFusionModule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 166,
    viewBox: "0 0 182 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H180C180.828 0.5 181.5 1.17157 181.5 2V91.1975C181.5 91.5838 181.351 91.9552 181.084 92.2343L160.229 114.037C159.946 114.333 159.555 114.5 159.145 114.5H2C1.17157 114.5 0.5 113.828 0.5 113V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "#1A171B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.119 71.7546C136.797 71.7546 136.644 72.0545 136.644 72.4025C136.644 72.7507 136.803 73.0077 137.125 73.0077C137.489 73.0077 137.647 72.7346 137.647 72.4187C137.647 72.0598 137.51 71.7546 137.119 71.7546ZM136.417 75V74.3306C137.183 74.2877 137.51 73.8004 137.632 73.3291C137.452 73.5326 137.262 73.6129 136.945 73.6129C136.459 73.6129 136 73.2166 136 72.4454C136 71.5938 136.47 71.1333 137.156 71.1333C137.806 71.1333 138.292 71.5724 138.292 72.6489C138.292 73.9289 137.732 74.8982 136.417 75Z",
    fill: "#1A171B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.689 71.7572V74.7725H140.061V71.7572H139.333V71.1333H141.417V71.7572H140.689Z",
    fill: "#1A171B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.333 74.7725V71.1333H144.863V74.1383H145.792V74.7725H144.333Z",
    fill: "#1A171B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.34 72.9737C148.283 72.693 148.207 72.2719 148.183 72.0899C148.159 72.2771 148.092 72.667 148.03 72.9634L147.939 73.4053H148.431L148.34 72.9737ZM148.717 74.7725L148.56 74.0135H147.81L147.653 74.7725H147.042L147.896 71.1333H148.479L149.333 74.7725H148.717Z",
    fill: "#1A171B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.723 73.1089H151.406V74.1746H151.743C152.1 74.1746 152.251 73.9615 152.251 73.66C152.251 73.2804 152.09 73.1089 151.723 73.1089ZM151.748 71.7312H151.406V72.5266H151.763C152.07 72.5266 152.165 72.3394 152.165 72.1315C152.165 71.8819 152.055 71.7312 151.748 71.7312ZM151.707 74.7725H150.792V71.1333H151.743C152.387 71.1333 152.789 71.5024 152.789 72.1055C152.789 72.4122 152.639 72.6929 152.357 72.8177C152.639 72.9321 152.875 73.1973 152.875 73.6443C152.875 74.393 152.462 74.7725 151.707 74.7725Z",
    fill: "#1A171B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.956 75C154.483 75 154.155 74.7323 153.917 74.4109L154.339 73.9236C154.548 74.2128 154.772 74.352 154.981 74.352C155.239 74.352 155.369 74.1966 155.369 73.945C155.369 73.7307 155.244 73.5594 154.836 73.3345C154.319 73.0452 154.006 72.7614 154.006 72.1401C154.006 71.5778 154.394 71.1333 154.981 71.1333C155.413 71.1333 155.682 71.3208 155.93 71.6689L155.518 72.1134C155.314 71.867 155.204 71.7813 154.966 71.7813C154.767 71.7813 154.638 71.9206 154.638 72.108C154.638 72.333 154.757 72.4722 155.135 72.6918C155.736 73.0399 156 73.297 156 73.9289C156 74.5501 155.602 75 154.956 75Z",
    fill: "#1A171B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 51,
    width: 6,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.377 51.692H145.794L145.791 56.0127H140.377V51.692Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.228 56.7494L145.039 56.4832L151.548 50.955L151.737 51.2206L145.228 56.7494Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.441 56.7494L144.251 56.4832L150.761 50.955L150.95 51.2206L144.441 56.7494Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.653 56.7494L143.464 56.4832L149.973 50.955L150.163 51.2206L143.653 56.7494Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.866 56.7491L142.677 56.4835L149.186 50.955L149.375 51.2206L142.866 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.079 56.7491L141.89 56.4835L148.399 50.955L148.588 51.2206L142.079 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.292 56.7491L141.102 56.4835L147.611 50.955L147.801 51.2206L141.292 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.505 56.7491L140.315 56.4835L146.824 50.955L147.013 51.2206L140.505 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.717 56.7491L139.528 56.4835L146.036 50.955L146.226 51.2206L139.717 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.93 56.7491L138.74 56.4835L145.249 50.955L145.438 51.2206L138.93 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.143 56.7491L137.954 56.4835L144.462 50.955L144.651 51.2206L138.143 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.356 56.7491L137.166 56.4835L143.674 50.955L143.864 51.2206L137.356 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.568 56.7491L136.379 56.4835L142.887 50.955L143.077 51.2206L136.568 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.781 56.7491L135.592 56.4835L142.1 50.955L142.29 51.2206L135.781 56.7491Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.994 56.7491L134.804 56.4835L141.313 50.955L141.502 51.2206L134.994 56.7491Z",
    fill: "#1A171B"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 45,
    width: 16,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.377 45H155.794V49.3212H140.377V45Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.887 44.2697L161.396 50.0256L161.202 50.2874L154.693 44.5314L154.887 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1 44.2697L160.609 50.0256L160.415 50.2874L153.906 44.5314L154.1 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.312 44.2697L159.821 50.0256L159.627 50.2874L153.118 44.5314L153.312 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.525 44.2697L159.034 50.0256L158.84 50.2874L152.331 44.5314L152.525 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 44.2697L158.247 50.0256L158.053 50.2874L151.543 44.5314L151.738 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.95 44.2697L157.459 50.0256L157.265 50.2874L150.756 44.5314L150.95 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.163 44.2697L156.672 50.0256L156.478 50.2874L149.969 44.5314L150.163 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.376 44.2697L155.885 50.0256L155.691 50.2874L149.181 44.5314L149.376 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.588 44.2697L155.097 50.0256L154.903 50.2874L148.394 44.5314L148.588 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.801 44.2697L154.31 50.0256L154.116 50.2874L147.607 44.5314L147.801 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.013 44.2697L153.522 50.0256L153.328 50.2874L146.819 44.5314L147.013 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.226 44.2697L152.735 50.0256L152.541 50.2874L146.032 44.5314L146.226 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.439 44.2697L151.948 50.0256L151.754 50.2874L145.245 44.5314L145.439 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.651 44.2697L151.16 50.0256L150.966 50.2874L144.457 44.5314L144.651 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67 44.5314L143.864 44.2697L150.373 50.0256L150.179 50.2874L143.67 44.5314Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.077 44.2697L149.586 50.0256L149.392 50.2874L142.883 44.5314L143.077 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.29 44.2697L148.798 50.0256L148.604 50.2874L142.095 44.5314L142.29 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.502 44.2697L148.011 50.0256L147.817 50.2874L141.308 44.5314L141.502 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.715 44.2697L147.224 50.0256L147.03 50.2874L140.521 44.5314L140.715 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.928 44.2697L146.436 50.0256L146.242 50.2874L139.734 44.5314L139.928 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14 44.2697L145.649 50.0256L145.455 50.2874L138.946 44.5314L139.14 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.353 44.2697L144.862 50.0257L144.667 50.2874L138.159 44.5314L138.353 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.566 44.2697L144.074 50.0257L143.88 50.2874L137.372 44.5314L137.566 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.779 44.2697L143.287 50.0257L143.093 50.2874L136.585 44.5314L136.779 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.991 44.2697L142.5 50.0257L142.306 50.2874L135.797 44.5314L135.991 44.2697Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.204 44.2697L141.713 50.0257L141.518 50.2874L135.01 44.5314L135.204 44.2697Z",
    fill: "#1A1919"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.377 45L136.104 48.9972C136.038 49.0583 136 49.1482 136 49.2428V51.7701C136 51.8645 136.038 51.9543 136.104 52.0155L140.377 56.0127V45Z",
    fill: "#1A171B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.794 64.9944H150.423V56.0003C150.423 55.9034 150.383 55.8125 150.315 55.751L145.794 51.6917V64.9944Z",
    fill: "#1A171B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.419 49.3212H140.378V45H141.419V49.3212Z",
    fill: "url(#paint0_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.377 56.0127H141.419V51.6972L140.377 51.692V56.0127Z",
    fill: "url(#paint1_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.794 56.0127H144.752V51.692H145.794V56.0127Z",
    fill: "url(#paint2_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 114.5H171.5V147.5H158.5V114.5Z",
    stroke: "#1A171B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166 114.5H179.5C180.605 114.5 181.5 113.605 181.5 112.5V98L166 114.5Z",
    fill: "#97110C",
    stroke: "#97110C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 37.5,
    width: 43,
    height: 45,
    rx: 1.5,
    stroke: "#1A171B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 147.5,
    width: 181,
    height: 18,
    rx: 1.5,
    stroke: "#1A171B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 114.5,
    width: 13,
    height: 33,
    stroke: "#1A171B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 114.5,
    width: 7,
    height: 33,
    stroke: "#1A171B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 114.5,
    width: 7,
    height: 33,
    stroke: "#1A171B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 136.5,
    width: 60,
    height: 11,
    stroke: "#1A171B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 125.5,
    width: 28,
    height: 11,
    stroke: "#1A171B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 140.377,
    y1: 47.1608,
    x2: 141.419,
    y2: 47.1608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1919",
    stopOpacity: 0.257048
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1919",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 140.377,
    y1: 53.8524,
    x2: 141.419,
    y2: 53.8524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1919",
    stopOpacity: 0.260708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1919",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 145.794,
    y1: 53.8524,
    x2: 144.752,
    y2: 53.8524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1919",
    stopOpacity: 0.260708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1919",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusionModule);
export default __webpack_public_path__ + "static/media/fusion-module.f6e1ba26a2074a1f4c0c700051613b70.svg";
export { ForwardRef as ReactComponent };